import React from "react";
import styles from "./OfferFilter.module.sass";
import Input, { inputType } from "../ui/Input/Input";
import Button from "../ui/Button/Button";
import { Collapse } from "react-bootstrap";
import currency from "../../utils/currency";
import SliderWrapper from "../SliderPrice/SliderPrice";
import { simulationType } from "../../containers/Products/Products";

class OfferFilter extends React.Component {
  state = {
    open: false,
  };

  filterOptions = [
    { value: "PARCELA_ASC", text: "Menor parcela" },
    { value: "PARCELA_DESC", text: "Maior parcela" },
    { value: "CREDITO_DESC", text: "Maior valor de crédito" },
    { value: "CREDITO_ASC", text: "Menor valor de crédito" },
    {
      value: "PROXIMITY",
      text:
        this.props.simulationType === simulationType.PARCELA
          ? "Parcela aproximada"
          : "Crédito aproximado",
    },
  ];

  render() {
    let filterElements;

    if (!this.props.isDesktop) {
      filterElements = (
        <div className={styles.OfferFilter}>
          <div
            onClick={() => this.setState({ open: !this.state.open })}
            className={styles.filterOffers}
          >
            Filtrar ofertas
            <i
              className={
                !this.state.open
                  ? "icon icon-seta-baixo-p"
                  : "icon icon-seta-cima-p"
              }
            />
          </div>
          <Collapse className={styles.filterContent} in={this.state.open}>
            <div>
              <p>Ordenar por:</p>
              <Input
                value={this.props.selectedSort}
                type={inputType.DROPDOWN}
                onSelect={(value) => this.props.sortChanged(value)}
                options={this.filterOptions}
              />
              <p>Alterar valor da parcela</p>
              <Input
                type={inputType.CURRENCY}
                valid={this.props.isValid}
                error={"Valor da parcela/total do crédito invalido."}
                value={this.props.value}
                onChange={this.props.valueChanged}
              />

              <Button
                disabled={!this.props.hasChanged || !this.props.isValid}
                onClick={this.props.reSimulate}
                id="alterOffer"
              >
                Alterar
              </Button>
            </div>
          </Collapse>
        </div>
      );
    } else {
      filterElements = (
        <div className={styles.OfferFilter}>
          <div className={styles.selectFilters}>
            <label className={styles.orderLabel}>Ordenar por: </label>
            <Input
              value={this.props.selectedSort}
              type={inputType.DROPDOWN}
              onSelect={(value) => this.props.sortChanged(value)}
              options={this.filterOptions}
            />
          </div>
          <SliderWrapper
            min={this.props.minValue}
            max={this.props.maxValue}
            step={this.props.simulationType === "parcela" ? 100 : 5000}
            value={currency.currencyToNumber(this.props.value)}
            onChange={this.props.valueChanged}
            simulationType={this.props.simulationType}
            customInput={
              <Input
                type={inputType.CURRENCY}
                valid={this.props.isValid}
                error={"Valor da parcela/total do crédito invalido."}
                value={this.props.value}
                onChange={this.props.valueChanged}
              />
            }
          />
          <Button
            disabled={!this.props.hasChanged || !this.props.isValid}
            onClick={this.props.reSimulate}
            id="alterOffer"
          >
            Alterar
          </Button>
        </div>
      );
    }

    return filterElements;
  }
}

export default OfferFilter;
